import Link from 'components/Link';
import Teaser from 'components/Teaser';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
// Import Components
import { Col, Row } from 'react-bootstrap';
// Import styles

import styles from './style.scss';

// var Shariff = require('shariff');

/*
*
* Shariff is being used locally (not NPM) in order to work on IE11, files are on /detail/shariff, CSS inside style.css and @fontface inside /styles/_variables.scss
*
*/

import Shariff from './shariff/shariff'

/**
 * Detail component
 */
@inject('MediahubStore', 'ViewStore')
@observer
class Detail extends Component {
  @observable loaded = false;

  componentDidMount() {
    this._fadeInImage();
  }

  componentDidUpdate(prevProps, prevState) {
    const url = !!document.referrer
      ? document.referrer
      : window.location.href;

    const shariff = new Shariff(this._buttons, {
      services:    ['facebook', 'twitter', 'xing', 'linkedin', 'mail', 'whatsapp'],
      mailUrl:     'mailto:',
      mailSubject: 'Toll Collect Video',
      theme:       'round',
      buttonStyle: 'icon',
      orientation: 'horizontal',
      url:         url,
    });

    this._fadeInImage();


  }

  _fadeInImage() {
    const { MediahubStore } = this.props;
    const mc                = MediahubStore.currentContainer;

    if(mc.previewImage) {
      const img  = new Image();
      img.onload = this._onImageLoad.bind(this);
      img.src    = mc.previewImage;
    } else {
      this._changeLoaded(false);
    }
  }

  _onImageLoad() {
    _.delay(() => {
      this._changeLoaded(true);
    }, 500);
  }

  @action
  _changeLoaded(bool) {
    this.loaded = bool;
  }

  render() {
    const { MediahubStore, ViewStore } = this.props;
    const mc                           = MediahubStore.currentContainer;

    if(_.isEmpty(mc)) {
      return null;
    }

    const isEnglish = _.startsWith(ViewStore.currentPath, '/en');

    const linkTo   = isEnglish
      ? 'channel'
      : 'overview';
    const channel  = isEnglish
      ? 'english'
      : '';
    const linkText = isEnglish
      ? ViewStore.get('showAll')
      : ViewStore.get('backToOverview');

    return (
      <div className={styles.detailContainer} >
        <div className={styles.detail_wrapper}>


        <Row >
          <Col xs={12} sm={12} >

            <h1
            // tabIndex={0}
            className={styles.mcTitle} >
              {mc.title}
            </h1 >

          </Col >
          {/* <Col xs={2} sm={3} > */}

            {/* <Link to={linkTo} channel={channel} className={styles.backToOverviewWrap} >
              <span >{linkText}</span >
              <div className={styles.gridIconWrap} >
              <svg x='0px' y='0px' viewBox='0 0 50 50' >
              <circle cx='24.5' cy='22.9' r='14.1' />
              <rect x='18.4' y='17.1' width='5.6' height='5.6' />
              <rect x='18.4' y='23.6' width='5.6' height='5.6' />
              <rect x='24.8' y='17.1' width='5.6' height='5.6' />
              <rect x='24.8' y='23.6' width='5.6' height='5.6' />
              </svg >
              </div >

            </Link > */}

          {/* </Col > */}
        </Row >
        <div
        className={styles.previewContainer}
        aria-label={mc.title}
            title={mc.title}
            tabIndex={ 0 }
        >
        {/* <img
             className={styles.emptyImage}
              src={''}
              tabIndex={ 0 }
              alt={mc.title} /> */}
          {_.isEqual(mc.type, 'video') && mc.player && (
            <iframe
            className={styles.iframe}
            src={mc.player}
            scrolling='no'
            frameBorder='0'
            allowFullScreen={true}
            aria-label={"Videoplayer: " + mc.title}
            title={mc.title}
            tabIndex={ 0 }
            />
            )}
          {_.isEqual(mc.type, 'image') && (
            <img
            className={this.loaded
              ? styles.imageLoaded
              : styles.previewImage}
              src={mc.previewImage}
              alt={mc.title} />
              )}

        </div >

        <Row >
          <Col xs={12} sm={12} className={styles.infoContainer} >

            {/* <p className={styles.mcInfo} >
              {_.isEqual(mc.type, 'image')
                ? `${mc.created}`
                : `${mc.created} | ${mc.duration}`}
            </p > */}

            <p className={styles.mcDescription} >
              {mc.description}
            </p >
          </Col >
          <Col xs={12} sm={12} className={styles.social} >
              <div className={styles.social_text}>
                {ViewStore.get('sharePost')}
              </div>
            <div
              ref={(ref) => this._buttons = ref}
              id='socialButtons'
              className='shariff'
              />
          </Col >
        </Row>
        </div>

        {!_.isEqual(mc.channelId, MediahubStore.featuredId) && (
          <DetailChannelTeaser />
          )}

        {!isEnglish && (
          <MostViewedTeaser />
        )}

      </div >
    );
  }
}

export default Detail;


const DetailChannelTeaser = inject('MediahubStore', 'ViewStore')(observer(({ MediahubStore, ViewStore }) => {
  return  (
    <div >
    {_.map(
      _.filter(MediahubStore.channels, (c, index) => c.id === MediahubStore.currentChannelId),
      (c, index) =>
      <Teaser
      key={`channel_${index}`}
      channelTitle={ViewStore.get('moreVideos')}
      channelLink={c.link}
      // channelLink={isEnglish
      //   ? 'english'
      //   : '/'}
        channelSize={c.channelSize}
        items={c.teasers}
        fromDetail
        />,
        )}
  </div >
)
}
));

const MostViewedTeaser = inject('MediahubStore')(observer(({ MediahubStore }) => (
  <div >
    {_.map(
      _.filter(MediahubStore.specialChannels, (c) => c.sortOption === 'countEmbeds'),
      (c, index) =>
        <Teaser
          key={`channel_${index}`}
          channelTitle={c.title}
          items={c.teasers}
        />,
    )}
  </div >
)));
